import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] px-4 py-12 text-center text-sm text-white/60" data-id="element-264">
      <div className="mx-auto max-w-4xl" data-id="element-265">
        <div className="mb-8 font-serif text-xl font-bold text-white" data-id="element-266">
          🎨 ART READY
        </div>
        <nav aria-label="Legal" className="mb-8 flex flex-wrap items-center justify-center gap-6" data-id="element-267">
          <a href="#terms" className="transition-colors hover:text-white" data-id="element-268">
            Terms &amp; Conditions
          </a>
          <a href="#privacy" className="transition-colors hover:text-white" data-id="element-269">
            Privacy Policy
          </a>
          <a href="#contact" className="transition-colors hover:text-white" data-id="element-270">
            Contact
          </a>
        </nav>
        <p data-id="element-271">© 2026 Art Ready — All rights reserved.</p>
      </div>
    </footer>;
}